<app-my-roche-banner> </app-my-roche-banner>
<div class="container">
  <div class="row">
    <div class="col">
      <rds-header [scrollTarget]="null" searchPosition="none"  (logoTriggered)="logoClick()" minimalMargins>
        <rds-header-app-name>RocheHome Newsletter Tool</rds-header-app-name>
        <rds-header-actions>
          <button rds-dropdown-toggle-icon-button [size]="'m'"npm
                  [rdsMenuTriggerFor]="gcsMenu"
                  #gcsMenuTrigger="rdsMenuTrigger"
                  [isOpen]="gcsMenuTrigger.menuOpen">
            <rds-icon class="action" namespace="outlined" icon="app_launcher"></rds-icon>
          </button>
          <rds-menu #gcsMenu="rdsMenu" class="gcs-menu"
                    xPosition="before"
                    yPosition="below">
            <rh-header-gcs-menu></rh-header-gcs-menu>
          </rds-menu>

        </rds-header-actions>
      </rds-header>
    </div>
  </div>
</div>
